import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import { fetchJitsiToken } from "../services/meeting.services";

export type JitsiTokenResponse = IApiResponse<{
    token: string;
    practice_id: string;
}>;

export function useFetchJitsiToken(
    roomName: string,
    onSuccess: (data: JitsiTokenResponse) => void
) {
    return useQuery<JitsiTokenResponse, AxiosError<JitsiTokenResponse>>({
        queryKey: ["jitsi-token", roomName],
        queryFn: () => fetchJitsiToken(roomName),
        cacheTime: 6 * 60 * 60 * 1000, // 6hrs
        staleTime: 6 * 60 * 60 * 1000, // 6hrs
        refetchOnMount: "always",
        onSuccess,
    });
}
